import { type FC } from "react";
import { IoIosClose } from "react-icons/io";
import { MoonLoader } from "react-spinners";
import type { ConfirmarCierreCajaModalProps } from "../types";

export const ConfirmarCierreCajaModal: FC<ConfirmarCierreCajaModalProps> = ({
  isSubmiting,
  onCancel,
  onConfirm,
  usuarioRuta,
}) => {
  return (
    <div className="w-full min-h-screen h-screen z-40 bg-black bg-opacity-50 px-2 md:px-8 flex justify-center items-center fixed top-0 left-0">
      <div className="bg-gray-200 w-[400px] max-w-full p-4 rounded-md relative flex flex-col items-center">
        <IoIosClose
          className={`absolute right-0 top-0 ${
            isSubmiting ? "cursor-not-allowed opacity-50" : "cursor-pointer"
          }`}
          size={40}
          onClick={isSubmiting ? undefined : onCancel}
        />

        <h2 className="text-center text-xl font-semibold">Cerrar caja</h2>
        <p className="mt-2 text-center font-semibold">
          {`Seguro que deseas cerrar la caja${
            usuarioRuta?.nombreRuta ? ` de ${usuarioRuta.nombreRuta}` : ""
          }?`}
        </p>
        <p className="mt-2 text-center text-sm text-gray-700">
          Se guardara un unico cierre para el dia actual. Si ya existe uno, no se
          creara otro.
        </p>

        <div className="mt-4 flex gap-2">
          <button
            type="button"
            className="bg-gray-500 text-white px-3 py-1 rounded-md min-w-[100px]"
            disabled={isSubmiting}
            onClick={onCancel}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="bg-[#8131bd] text-white px-3 py-1 rounded-md flex justify-center items-center min-w-[120px]"
            disabled={isSubmiting}
            onClick={onConfirm}
          >
            {isSubmiting ? <MoonLoader size={20} color="#ffffff" /> : "Confirmar"}
          </button>
        </div>
      </div>
    </div>
  );
};
